import clsx from 'clsx';
import React from 'react';
import styles from './index.module.scss';
import { ArrowIcon } from 'src/components/shared/elements/icons/ArrowIcon';
import { DoubleArrowIcon } from 'src/components/shared/elements/icons/DoubleArrowIcon';

type Props = {
  pageNumberList: (number | React.JSX.Element)[];
  current: number;
  isFirstPage: boolean;
  isLastPage: boolean;
  goToFirstPage: () => void;
  goToPreviousPage: () => void;
  goToNextPage: () => void;
  goToDesignatedPage: (page: number) => void;
};

export const Presenter: React.FC<Props> = ({
  pageNumberList,
  current,
  isFirstPage,
  isLastPage,
  goToFirstPage,
  goToPreviousPage,
  goToNextPage,
  goToDesignatedPage,
}) => (
  <ul className={styles.container}>
    {isLastPage && (
      <li className={clsx(styles.pageItem)} onClick={goToFirstPage} data-testid="goToFirstPage">
        <DoubleArrowIcon />
      </li>
    )}
    {!isFirstPage && (
      <li className={clsx(styles.pageItem, styles.arrow)} onClick={goToPreviousPage} data-testid="goToPreviousPage">
        <ArrowIcon direction="left" className={styles.arrowIcon} fillColor="#B4B8BE" />
      </li>
    )}
    <div className={styles.pageNumberContainer}>
      {pageNumberList.map((page, i) => (
        <li
          key={i}
          className={clsx(styles.pageItem, page === current && styles.selected)}
          onClick={() => {
            typeof page === 'number' && page !== current && goToDesignatedPage(page);
          }}
          data-testid={typeof page === 'number' ? `page-${page}` : 'ellipse'}
        >
          {typeof page === 'number' ? page : page}
        </li>
      ))}
    </div>
    {!isLastPage && (
      <li className={clsx(styles.pageItem, styles.arrow)} onClick={goToNextPage} data-testid="goToNextPage">
        <ArrowIcon direction="right" className={styles.arrowIcon} fillColor="#B4B8BE" />
      </li>
    )}
  </ul>
);
